import { Table, Button } from 'antd';
import React, { Component } from 'react';
import { columns3 } from './data';

class index extends Component {
    render() {
        const { data, print, onExport } = this.props;
        return (
            <div>
                <div className="table-title">Coffee Shop Key Performance Indicator 咖啡厅关键绩效指数</div>
                <Table
                    columns={columns3()}
                    dataSource={data.data3}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    id="table5_10_3"
                    scroll={print ? {} : { x: 3350, y: false }}
                    rowKey={v => v.sort}
                />
                {print ? null : <Button
                    className='export-btn'
                    type="primary"
                    onClick={() => onExport('table5_10_3', 'Coffee Shop Key Performance Indicator 咖啡厅关键绩效指数')}
                    loading={print}
                >导出Excel</Button>}
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/Table5_10_3.js